import { CourseFormatEnum } from '@/models/Course';
import { useTranslation } from 'react-i18next';
import { Colors, Sizes } from '@/components/ui/types';
import { Badge } from '@/components/ui/daisy';

type BadgeFormatsProps = {
  formats: CourseFormatEnum[];
  size: Sizes;
};

export default function BadgeFormats({ formats, size }: BadgeFormatsProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'courseFormats',
  });
  const colorsMap: Record<CourseFormatEnum, Colors> = {
    [CourseFormatEnum.IN_PERSON]: 'primary',
    [CourseFormatEnum.ONLINE]: 'secondary',
    [CourseFormatEnum.SCHOOL]: 'default',
    [CourseFormatEnum.EXTRA_COURSE]: 'default',
    [CourseFormatEnum.SELF_PACED]: 'default',
  };
  return (
    <div className="flex items-center max-xl:gap-2 gap-4 shrink-0">
      {formats.map(format => (
        <Badge key={format} color={colorsMap[format]} size={size}>
          {t(format)}
        </Badge>
      ))}
    </div>
  );
}
